import { ITicker, ITokenInfo } from '@kattana-io/common';
import {
  formatBaseVolume,
  formatLiquidity,
  ColumnNames,
} from '../../components/Modal/TickersModal/helpers';
import useTicker from '../../hooks/useTicker';
import { formatAPY } from '../../helpers/formatters';
import { SEOStatisticsField } from '../../components/SEO/Sidebar';

export const getPriceUSD = (address: string, ticker?: ITicker) => {
  if (!ticker) {
    return 0;
  }

  if (ticker?.base_address.toLowerCase() === address?.toLowerCase()) {
    return ticker?.price_a_usd;
  }

  return ticker?.price_b_usd;
};

export const getTokenStatistics = (
  token: ITokenInfo,
  priceUSD: number
): Record<string, SEOStatisticsField> => {
  const {
    max_for_last_day,
    max_for_last_week,
    min_for_last_day,
    min_for_last_week,
  } = token.price_statistics || {};

  return {
    [`${token.title} Price`]: { type: 'price', value: priceUSD },
    '24h Low / 24h High': {
      type: 'complexPrice',
      leftValue: min_for_last_day || 0,
      divider: '/',
      rightValue: max_for_last_day || 0,
    },
    '7d Low / 7d High': {
      type: 'complexPrice',
      leftValue: min_for_last_week || 0,
      divider: '/',
      rightValue: max_for_last_week || 0,
    },
    'Trading Volume': {
      type: 'default',
      value: formatBaseVolume(token.total_trading_volume) || 0,
    },
  };
};

export const getTokenTableData = (pairs: ITicker[]) => {
  return pairs.map((item, index) => {
    const ticker = useTicker(item);

    return {
      [ColumnNames.star]: `${index + 1}`,
      [ColumnNames.exchange]: item.exchange,
      [ColumnNames.pair]: `${item.chain}-${item.address}`,
      [ColumnNames.price]: ticker.price_usd,
      [ColumnNames.liquidity]: formatLiquidity(item.liquidity) || '-',
      [ColumnNames.volume]: formatBaseVolume(item.volume) || '-',
      [ColumnNames.contract]: item.address,
      [ColumnNames.apy]: formatAPY(item.annual_percentage_yield) || '-',
    };
  });
};

export const getMobileTokenTableData = (pairs: ITicker[]) => {
  return pairs.map((item, index) => {
    const ticker = useTicker(item);

    return {
      [ColumnNames.star]: `${index + 1}`,
      [ColumnNames.exchange]: item,
      [ColumnNames.pair]: item,
      [ColumnNames.price]: ticker.price_usd,
      [ColumnNames.liquidity]: formatLiquidity(item.liquidity) || '-',
      [ColumnNames.volume]: formatBaseVolume(item.volume) || '-',
      [ColumnNames.contract]: item,
      [ColumnNames.apy]: formatAPY(item.annual_percentage_yield) || '-',
    };
  });
};
